<app-navbar-small></app-navbar-small>
<div class="m-lg-4" style="height: 60vh">
  <div class="row d-flex justify-content-center">
    <h2 class="deep-purple-text"><b>Test and Verify with Other Classifiers</b></h2>
  </div>
  <div class="m-lg-4 row d-flex justify-content-around">
    <button type="button" mdbBtn color="secondary" class="text-capitalize" mdbWavesEffect
            (click)="testWithOtherClassifier('smote_bagging')">OnlineSMOTEBaggingClassifier</button>
    <button type="button" mdbBtn color="info" class="text-capitalize" mdbWavesEffect
            (click)="testWithOtherClassifier('under_over_bagging')">OnlineUnderOverBaggingClassifier</button>

  </div>
  <div class="m-lg-4 row d-flex justify-content-around">
    <div class="col-4 m-md-3">
      <mdb-card>
        <div class="view rgba-white-slight waves-light" mdbWavesEffect>
        </div>
        <!--Card content-->
        <mdb-card-body>
          <!--Title-->
          <mdb-card-title>
            <h4 class="text-secondary">OnlineSMOTEBaggingClassifier</h4>
          </mdb-card-title>

          <!--Text-->
          <mdb-card-text class="flex-column">
            <p>Reference: B. Wang and J. Pineau, “Online Bagging and Boosting for
              Imbalanced Data Streams,” in IEEE Transactions on Knowledge
              and Data Engineering, vol. 28, no. 12, pp. 3353-3366, 1 Dec. 2016.
              doi: 10.1109/TKDE.2016.2609424</p>
<!--            <p>Kappa: {{ evaluationMeanMeasures.kappa }}<br></p>-->
<!--            <p>Accuracy: {{ evaluationMeanMeasures.accuracy }}<br></p>-->
<!--            <p>Recall: {{ evaluationMeanMeasures.recall }}<br></p>-->
<!--            <p>Precision: {{ evaluationMeanMeasures.precision }}<br></p>-->
<!--            <p>F1 Score: {{ evaluationMeanMeasures.fScore }}<br></p>-->
          </mdb-card-text>

        </mdb-card-body>
      </mdb-card>
    </div>
    <div class="col-4 m-md-3">
      <mdb-card>
        <div class="view rgba-white-slight waves-light" mdbWavesEffect>
        </div>
        <!--Card content-->
        <mdb-card-body>
          <!--Title-->
          <mdb-card-title>
            <h4 class="text-info">OnlineUnderOverBaggingClassifier</h4>
          </mdb-card-title>

          <!--Text-->
          <mdb-card-text class="flex-column">
            <p>Reference: B. Wang and J. Pineau, “Online Bagging and Boosting for Imbalanced Data Streams,
              ” in IEEE Transactions on Knowledge and Data Engineering, vol. 28, no. 12, pp. 3353-3366, 1 Dec. 2016.
              doi: 10.1109/TKDE.2016.2609424 </p>
<!--            <p>Kappa: {{ evaluationMeanMeasures.kappa }}<br></p>-->
<!--            <p>Accuracy: {{ evaluationMeanMeasures.accuracy }}<br></p>-->
<!--            <p>Recall: {{ evaluationMeanMeasures.recall }}<br></p>-->
<!--            <p>Precision: {{ evaluationMeanMeasures.precision }}<br></p>-->
<!--            <p>F1 Score: {{ evaluationMeanMeasures.fScore }}<br></p>-->
          </mdb-card-text>

        </mdb-card-body>
      </mdb-card>
    </div>


  </div>
  <div><table mdbTable striped="true">
    <thead>
    <tr>
      <th *ngFor="let head of headElements" scope="col">{{head}} </th>
    </tr>
    </thead>
    <div *ngIf="(items | async)?.length==0">
      <p class="container -align-center">No records are available!</p></div>
    <tbody>
    <tr mdbTableCol *ngFor="let item of items | async">
      <th scope="row">{{item.key}}</th>
      <td>{{item.yPred}}</td>
      <td>{{item.smoteBagging}}</td>
      <td>{{item.underOverBagging}}</td>
      <td>
        <mdb-icon fas icon="check-circle" size="2x" class="teal-text mx-sm-1" (click)="verifyItemCorrect(item.key)">
        </mdb-icon><mdb-icon fas icon="times-circle" size="2x" class="pink-text mx-sm-1" (click)="verifyItemWrong(item.key)"></mdb-icon>
      </td>

      <td class="mdb-color lighten-3">{{item.targetClass}}</td>
    </tr>
    </tbody>
  </table>
  </div>
</div>

